import React from 'react'

const CreateShippingForm = () => {
  return (
    <div>CreateShippingForm</div>
  )
}

export default CreateShippingForm